export default "__VITE_ASSET__725aa6f7__"